import { effect, signal, Signal } from "@angular/core";
import { AbstractControl, FormGroup } from "@angular/forms";
import { PremisesType } from "../../modules/admin/projects/premises-management/premises.types";

/* eslint-disable no-bitwise */
export class Utils {

    constructor() { }

    public static interfaceOf<T>(value: any, fieldName: string): value is T {
        return fieldName in value;
    }

    static generateRandomId(length = 8) {
        let id = '';
        let dt = new Date().getTime();
        for (let i = 0; i < length; i++) {
            const r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            id += r.toString(16);
        }
        return id;
    }

    /**
     * @description Devuelve si un carácter es letra o no.
     */
    public static isCharacterALetter(character): boolean {
        return character.length === 1 && character.match(/[a-z]/i);
    }

    /**
     * @description Devuelve si un carácter es un número.
     */
    public static isCharacterANumber(character): boolean {
        return character.length === 1 && character.match(/[0-9]/i);
    }

    public static removeAccents(str: string) {
        return str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    public static debouncedSignal<T>(input: Signal<T>, timeOutMs = 0): Signal<T> {
        const debounceSignal = signal(input());
        effect(() => {
            const value = input();
            const timeout = setTimeout(() => {
               debounceSignal.set(value);
            }, timeOutMs);
            return () => {
               clearTimeout(timeout);
            };
        });
        return debounceSignal;
    }

    public static allControlsEmpty(form: FormGroup): boolean {
        if (!form || !form.controls) {
            return true;
        }
        return Object.values(form.controls).every(control => {
            const value = control.value;
            return value === null || value === undefined || value === '';
        });
    }

    public static isCenterOrHotel(type : PremisesType | string): boolean {
        return type === PremisesType.CENTER || type === PremisesType.HOTEL;
    }

    public static areStringListsEqual(a: string[], b: string[]): boolean {
        if (a.length !== b.length) return false;
        return a.every((item, index) => item === b[index]);
    }

    public static addError(ctrl: AbstractControl, key: string) {
        ctrl.setErrors({ ...ctrl.errors, [key]: true });
    }

    public static removeError(ctrl: AbstractControl, key: string) {
        const current = { ...ctrl.errors };
        delete current[key];
        ctrl.setErrors(Object.keys(current).length ? current : null);
    }

    public static isPremisesGenericType(type: PremisesType | string): boolean {
        return type !== PremisesType.CENTER && type !== PremisesType.HOTEL;
    }

    public static getCommonValue<T, K extends keyof T>(items: T[], key: K): T[K] | undefined {
        if (items.length === 0) return undefined;

        const firstValue = items[0][key];
        const allMatch = items.every(item => item[key] === firstValue);

        return allMatch ? firstValue : undefined;
    }

    public static getCommonValuePrimitive<T>(items: T[]): T | undefined {
        if (items.length === 0) return undefined;

        const firstValue = items[0];
        const allMatch = items.every(item => item === firstValue);

        return allMatch ? firstValue : undefined;
    }
}
